module.exports = __webpack_public_path__ + "static/media/1-yellowcube.ea952194.png";